import BASE_API from '@/api/dataBase';
export const searchColumns = (ctx) => {
  return [
    {
      prop: 'settlementNo',
      name: '结算单编号',
      type: 'input',
      disabled: true,
    },
    {
      prop: 'settlementCompanyNo',
      name: '公司名称',
      type: 'select',
      options: ctx.companyList,
      value: 'personCompanyCode',
      label: 'personCompanyName',
      changeMethod: 'changeMethod',
      // disabled: true,
      // disabled:
      //   ['create'].includes(ctx.$route.query?.status) && ctx.$route.query?.id
      //     ? true
      //     : !ctx.isCreate,
    },
    {
      prop: 'settlementDepartmentNo',
      name: '部门',
      type: 'select',
      // disabled: true,
      disabled:
        ['create'].includes(ctx.$route.query?.status) && ctx.$route.query?.id
          ? true
          : ctx.baseFormData?.settlementCompanyNo == '' || !ctx.isCreate,
      options: ctx.departmentList,
      value: 'personDepartmentCode',
      label: 'personDepartmentName',
      changeMethod: 'changeMethod',
    },
    {
      name: '合同编号',
      prop: 'contractNo',
      type: 'searchTableSpec',
      searchType: 'leaseContract',
      extraData: {
        parkCompanyNo: ctx.baseFormData.settlementCompanyNo,
        parkDepartmentNo: ctx.baseFormData.settlementDepartmentNo,
        // contractStatus: '03',
      },
      isMultiple: true,
      changeMethod: 'changeMethod',
      currentValue: ctx.baseFormData?.contractNo,
      disabled: !ctx.isCreate,
      // disabled:
      //   ['create'].includes(ctx.$route.query?.status) && ctx.$route.query?.id
      //     ? true
      //     : ctx.baseFormData?.settlementCompanyNo == '' || !ctx.isCreate,
    },
    {
      name: '供应商名称',
      prop: 'supplierName',
      type: 'searchTableSpec',
      searchType: 'partner',
      extraData: {
        settlementCompanyNo: ctx.baseFormData.settlementCompanyNo,
        departmentCode: ctx.baseFormData.settlementDepartmentNo,
        partnerTypes: 'HZHB02',
      },
      isMultiple: true,
      disabled: true,
      changeMethod: 'changeMethod',
      currentValue: ctx.baseFormData?.supplierName,
    },
    {
      name: '结算日期',
      prop: 'settlementDate',
      type: 'date',
      disabled: !ctx.isCreate,
    },
    {
      prop: 'payableAccountPeriod',
      name: '应付账期',
      type: 'date',
      visible: true,
      format: 'yyyy-MM',
    },
    {
      name: '原币结算总金额（含税）',
      prop: 'originalTotalAmount',
      type: 'input',
      precision: 2,
      max: 999999999,
      disabled: true,
    },
    {
      name: '本币结算总金额（含税）',
      prop: 'domesticTotalAmount',
      type: 'input',
      precision: 2,
      max: 999999999,
      disabled: true,
    },
    {
      name: '结算单状态',
      prop: 'settlementStatus',
      type: 'select',
      options: ctx.dictListMap?.settlementStatus || [],
      disabled: true,
    },
    {
      name: '结算单类型',
      prop: 'settlementType',
      type: 'select',
      options: ctx.dictListMap?.settlementType || [],
    },
    {
      name: '业务类别',
      prop: 'settlementBusinessType',
      type: 'select',
      disabled: true,
      options: ctx.dictListMap?.businessCategoryPayable || [],
    },
    {
      name: '币种',
      prop: 'currencyCode',
      type: 'ajaxSelect',
      apiUrl: BASE_API.LIST_CURRENCY,
      clearable: true,
      filterable: true,
      valueKey: 'currencyCode',
      labelKey: 'currencyName',
      changeMethod: 'changeMethod',
      method: 'get',
      valueType: 'object',
      disabled: true,
    },
    {
      name: '汇率',
      prop: 'exchangeRate',
      type: 'inputNumber',
      disabled: true,
    },
    {
      prop: 'exchangeDate',
      name: '汇率日期',
      type: 'date',
    },
    // ?
    {
      name: '是否代付',
      prop: 'anotherPayFlag',
      type: 'checkbox',
    },
    {
      name: '代付平台',
      prop: 'anotherPayPlatform',
      type: 'input',
      disabled: !ctx.baseFormData.anotherPayFlag,
    },
    {
      name: '付款状态',
      prop: 'paymentStatus',
      type: 'select',
      options: ctx.dictListMap?.pay_paymentStatus || [],
      disabled: true,
    },
    {
      name: '已付款金额',
      prop: 'paidAmount',
      type: 'inputNumber',
      precision: 2,
      max: 999999999,
      placeholder: '自动生成',
      disabled: true,
    },
    {
      name: '未付款金额',
      placeholder: '自动生成',
      prop: 'unpaidAmount',
      precision: 2,
      max: 999999999,
      type: 'inputNumber',
      disabled: true,
    },
    {
      name: '是否已打印',
      prop: 'printFlag',
      type: 'checkbox',
      disabled: true,
    },
    {
      name: '业务人员',
      prop: 'salesmanName',
      type: 'searchTableSpec',
      searchType: 'personnel',
      isMultiple: true,
      currentValue: ctx.baseFormData?.salesmanName,
      disabled: true,
    },
    {
      name: '创建日期',
      prop: 'settlementCreateDate',
      type: 'date',
      disabled: true,
    },
    {
      name: '备注',
      prop: 'remark',
      type: 'textarea',
      span: 24,
    },
  ];
};
export const formRules = (ctx) => {
  return {
    settlementCompanyNo: [{ required: true, message: '公司名称必填', trigger: 'change' }],
    settlementDepartmentNo: [{ required: true, message: '部门必填', trigger: 'change' }],
    contractNo: [{ required: true, message: '合同编号必填', trigger: 'change' }],
    // supplierName: [{ required: true, message: '供应商名称', trigger: 'change' }],
    settlementDate: [{ required: true, message: '结算日期必填', trigger: 'change' }],
    originalTotalAmount: [{ required: true, message: '原币总金额必填', trigger: 'change' }],
    domesticTotalAmount: [{ required: true, message: '本币总金额必填', trigger: 'change' }],
    settlementType: [{ required: true, message: '结算单类型必填', trigger: 'change' }],
    currencyCode: [{ required: true, message: '币种必填', trigger: 'change' }],
    exchangeRate: [{ required: true, message: '汇率必填', trigger: 'change' }],
    salesmanName: [{ required: true, message: '业务人员必填', trigger: 'change' }],
    settlementCreateDate: [{ required: true, message: '创建日期必填', trigger: 'change' }],
    anotherPayPlatform: [
      { required: ctx.baseFormData.anotherPayFlag, message: '创建日期必填', trigger: 'change' },
    ],
  };
};
import { formatDate } from '@/utils/date';
export default {
  name: 'LeaseContractForm',
  data() {
    return {
      baseFormData: {
        payableSettlementNo: '',
        settlementCompanyNo: '',
        settlementCompanyName: '',
        settlementDepartmentNo: '',
        settlementDepartmentName: '',
        contractNo: undefined,
        supplierName: '',
        supplierNo: '',
        settlementDate: '',
        originalTotalAmount: '',
        domesticTotalAmount: '',
        settlementStatus: '',
        settlementType: '',
        currencyCode: '',
        currencyName: '',
        exchangeRate: '',
        exchangeDate: '',
        anotherPayFlag: false,
        anotherPayPlatform: '',
        paymentStatus: '',
        paidAmount: '',
        unpaidAmount: '',
        printFlag: '',
        salesmanName: '',
        salesmanNo: '',
        remark: '',
      },
      // formRules: {},
      companyList: [],
      departmentList: [], //部门列表
      businessCategoryList: [
        {
          value: '01',
          label: '贸易',
        },
        {
          value: '02',
          label: '多式联运',
        },
        {
          value: '03',
          label: '园区仓储',
        },
        {
          value: '04',
          label: '园区物业',
        },
        {
          value: '05',
          label: '三方租赁',
        },
      ],
    };
  },
  computed: {
    formColumn() {
      return searchColumns(this);
    },
    formRules() {
      return formRules(this);
    },
  },
  mounted() {
    this.$nextTick(() => {
      this._getCompanyApi();
    });
    this.initFormData();
  },
  methods: {
    initFormData() {
      console.log(this.$route.query, '1111');
      if (['create'].includes(this.$route.query?.status) && !this.$route.query?.id) {
        this.baseFormData = {
          ...this.baseFormData,
          settlementDate: formatDate(new Date()),
          settlementCreateDate: formatDate(new Date()),
          settlementCompanyNo: this.userInfo.companyCode,
          settlementCompanyName: this.userInfo.companyName,
          settlementDepartmentNo: this.userInfo.departmentCode,
          settlementDepartmentName: this.userInfo.departmentName,
          originalTotalAmount: '0',
          domesticTotalAmount: '0',
          settlementBusinessType: '04',
          settlementType: '2',
          exchangeDate: formatDate(new Date()),
          salesmanName: this.userInfo.userName,
          salesmanNo: this.userInfo.userCode,
        };
      }
    },
    changeMethod({ val, prop }) {
      console.log(val, prop, '点击切换');
      const rowData = val && Array.isArray(val) ? val[0] : val;
      if (prop === 'currencyCode') {
        this.baseFormData = {
          ...this.baseFormData,
          currencyCode: val?.currencyCode,
          currencyName: val?.currencyName,
        };
      } else if (prop == 'salesmanNo') {
        // this.query.salesmanNo = val[0]?.personNo || '';
        this.baseFormData = {
          ...this.baseFormData,
          salesmanName: rowData.personName || '',
          salesmanNo: rowData.personNo || '',
        };
      } else if (prop == 'contractNo') {
        this.baseFormData = {
          ...this.baseFormData,
          contractNo: rowData.contractNo,
          supplierNo: rowData.partnerCode,
          supplierName: rowData.partnerName,
          settlementCompanyNo: rowData.companyCode,
          settlementCompanyName: rowData.companyName,
          departmentCode: rowData.departmentCode,
          companyName: rowData.companyName,
          companyCode: rowData.companyCode,
          departmentName: rowData.departmentName,
          // settlementStatus: rowData.contractStatus,
          originalTotalAmount: '0',
          domesticTotalAmount: '0',
          paidAmount: '0',
          unpaidAmount: '0',
          currencyCode: rowData.currencyCode || 'CNY',
          currencyName: rowData.currencyName || '中国人民币（国际）',
          exchangeRate: rowData.exchangeRate || '1',
          salesmanName: rowData?.salesmanName || this.userInfo.userName,
          salesmanNo: rowData?.salesmanNo || this.userInfo.userCode,
          settlementCreateDate: rowData?.salesmanNo || formatDate(new Date()),
        };
        // 清空结算行数据
        this.changeContractHandler();
      } else if (prop == 'settlementCompanyNo') {
        const item = this.companyList.find((item) => item.personCompanyCode == rowData);
        console.log(item);
        this.baseFormData = {
          ...this.baseFormData,
          settlementDepartmentNo: '',
          businessDepartmentName: '',
          contractNo: '',
          settlementCompanyNo: rowData,
          settlementCompanyName: item.personCompanyName ? item.personCompanyName : '',
        };
        console.log('this.contractNo==', this.baseFormData.contractNo);
        // 获取部门数据
        this._getDepartmentByCompanyCodeApi(this.baseFormData.settlementCompanyNo);
      }
    },
    // 获取公司
    async _getCompanyApi() {
      const { data } = await this.$axios.post(BASE_API.GET_PERSON_API, {
        id: this.userInfo.userCode,
        userCode: this.userInfo.userCode,
        personName: this.userInfo.userName,
      });
      if (data.code == 0) {
        this.companyList = data.data?.personCompanyInfo;
        this._getDepartmentByCompanyCodeApi(this.baseFormData.settlementCompanyNo);
      } else {
        console.error('获取公司失败');
      }
    },
    // 根据公司获取部门
    async _getDepartmentByCompanyCodeApi(settlementCompanyNo) {
      const { data } = await this.$axios.post(BASE_API.GET_PERSON_API, {
        id: this.userInfo.userCode,
        userCode: this.userInfo.userCode,
        personName: this.userInfo.userName,
        personCompanyCode: settlementCompanyNo,
      });
      if (data.code == 0) {
        this.departmentList = data.data?.personDepartmentInfo;
      } else {
        console.error('获取部门失败');
      }
    },

    // 切换部门
    changeDepartmentHandler(val) {
      const item = this.departmentList.find((item) => item.personDepartmentCode == val);
      this.baseFormData = {
        ...this.baseFormData,
        settlementDepartmentNo: val,
        settlementDepartmentName: item.personDepartmentName,
      };
    },
  },
};
